import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import StatisticsIncrementor from "../../statistics/StatisticsIncrementor";
import FreeUpgrade from "./FreeUpgrade";
import UpgradeCreator from "./UpgradeCreator";

export default class MinedOreUpgrade extends FreeUpgrade {
    /**
     * @param {UpgradeCreator} upgradeCreator 
     * @param {string} title
     * @param {string} iconFileName
     * @param {BigNum} ore
     * @param {Totals} totals
     * @param {StatisticsIncrementor} statisticsIncrementor
     */
    constructor(upgradeCreator, title, iconFileName, ore, totals, statisticsIncrementor) {
        super(upgradeCreator, title, iconFileName);

        /**
         * @constant
         * @type {BigNum}
         */
        this.ore = ore;
        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {StatisticsIncrementor}
         */
        this.statisticsInc = statisticsIncrementor;

    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @override
     */
    onUpgradePurchased() {
        this.totals.incrementOre(this.ore);

        this.statisticsInc.incrementOre(this.ore);
        this.statisticsInc.incrementUpgradeOre(this.ore);
    }

    /**
     * @override
     * @returns {boolean}
     */
    isCombineSupported() {
        return true;
    }

}